import React, { useState } from "react";
import { Loader2, FileText, Mail } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";
import { API, authHeaders } from "./shared";

export default function ReportTab({ clients }) {
  const now = new Date();
  const defaultMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
  const [month, setMonth] = useState(defaultMonth);
  const [sending, setSending] = useState({});

  const viewPdf = (email) => {
    const token = localStorage.getItem("mv_admin_token");
    window.open(`${API}/admin/warehouse/report/pdf?month=${month}&client_email=${email}&token=${token}`, "_blank");
  };

  const sendEmail = async (email) => {
    setSending(s => ({ ...s, [email]: true }));
    try {
      await axios.post(`${API}/admin/warehouse/report/send-email?month=${month}&client_email=${email}`, {}, authHeaders());
      toast.success("Report inviato via email");
    } catch (err) { toast.error(err.response?.data?.detail || "Errore invio"); }
    setSending(s => ({ ...s, [email]: false }));
  };

  const sendAll = async () => {
    for (const c of clients) {
      await sendEmail(c.email);
    }
  };

  return (
    <div className="space-y-4" data-testid="report-tab">
      <div className="bg-white border border-zinc-200 rounded-sm p-4">
        <div className="flex flex-wrap items-center gap-4">
          <div>
            <label className="block text-xs font-bold uppercase text-zinc-500 mb-1">Mese</label>
            <input type="month" value={month} onChange={e => setMonth(e.target.value)} data-testid="report-month"
              className="border border-zinc-200 rounded-sm px-3 py-2 text-sm" />
          </div>
          <div className="flex-1" />
          <button onClick={sendAll} data-testid="send-all-reports-btn"
            className="flex items-center gap-2 bg-[#FF5200] text-white px-4 py-2.5 rounded-sm text-sm font-bold uppercase hover:bg-[#e64a00] transition-colors">
            <Mail size={16} /> Invia Report a Tutti
          </button>
        </div>
      </div>

      <div className="bg-white border border-zinc-200 rounded-sm">
        <table className="w-full text-sm" data-testid="report-clients-table">
          <thead><tr className="bg-[#09090B] text-white text-xs uppercase tracking-wider">
            <th className="px-4 py-3 text-left">Cliente</th>
            <th className="px-4 py-3 text-left">Email</th>
            <th className="px-4 py-3 text-center">Azioni</th>
          </tr></thead>
          <tbody>
            {clients.length === 0 ? (
              <tr><td colSpan="3" className="text-center py-8 text-zinc-400">Nessun cliente magazzino attivo</td></tr>
            ) : clients.map((c, i) => (
              <tr key={c.email} className="border-b border-zinc-100 hover:bg-zinc-50">
                <td className="px-4 py-3 font-semibold">{c.company || c.name}</td>
                <td className="px-4 py-3 text-zinc-500 font-mono text-xs">{c.email}</td>
                <td className="px-4 py-3 text-center">
                  <div className="flex items-center justify-center gap-2">
                    <button onClick={() => viewPdf(c.email)} data-testid={`view-pdf-${i}`}
                      className="flex items-center gap-1 px-3 py-1.5 bg-[#09090B] text-white text-xs font-bold uppercase rounded-sm hover:bg-zinc-700">
                      <FileText size={14} /> PDF
                    </button>
                    <button onClick={() => sendEmail(c.email)} disabled={sending[c.email]} data-testid={`send-email-${i}`}
                      className="flex items-center gap-1 px-3 py-1.5 bg-[#FF5200] text-white text-xs font-bold uppercase rounded-sm hover:bg-[#e64a00] disabled:opacity-50">
                      {sending[c.email] ? <Loader2 size={14} className="animate-spin" /> : <Mail size={14} />} Email
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
